<template>
  <div>
    <BaseTitle
      :title="
        this.type === 'cerdas-admin' ? $t('content.setting_lite') : this.type === 'school-admin' ? $t('content.setting_class') : $t('content.e_rapor')
      "
    />
    <v-row>
      <v-col v-for="(item, index) in items" :key="index" md="4">
        <div class="class-item" @click="gotoPage(item)">
          <svg-icon :icon="item.icon" width="198" height="140" />
          <strong class="class-item-title" v-if="item.icon == 'cerdas_feature'">{{ $t('content.cerdas_feature') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'change_storage'">{{ $t('content.change_storage') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'class_level_set'">{{ $t('content.class_level') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'class_acc_set'">{{ $t('content.class_accel') }}</strong>
          <strong class="class-item-title" v-if="item.icon == 'template_erapor'">{{ $t('content.template_e_rapor') }}</strong>
          <!-- <strong class="class-item-title" v-if="item.icon == 'template_integ'">{{ $t('content.template_integ') }}</strong> -->
          <strong class="class-item-title" v-if="item.icon == 'template_generate'">{{ $t('content.template_generate') }}</strong>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';

export default {
  name: 'MenuListLite',
  components: {
    BaseTitle
  },
  props: {
    type: {
      type: String
    }
  },
  computed: {
    ...mapGetters({})
  },
  data: () => ({
    items: []
  }),
  methods: {
    getData() {
      switch (this.type) {
        case 'cerdas-admin':
          this.items = [
            { icon: 'cerdas_feature', link: { name: 'RoleLite' } },
            { icon: 'change_storage', link: { name: 'ChangeStorage' } }
          ];
          break;
        case 'school-admin':
          this.items = [
            { icon: 'class_level_set', link: { name: 'ClassSettingIndex' } },
            { icon: 'class_acc_set', link: { name: 'ClassAccelIndex' } }
          ];
          break;
        case 'teacher':
          this.items = [
            { icon: 'template_erapor', link: { name: 'eRaporTemplateIndex' } },
            // { icon: 'template_integ', link: { name: 'eRaporIntegIndex' } },
            { icon: 'template_generate', link: { name: 'eRaporGeneratorIndex' } }
          ];
          break;
      }
    },
    gotoPage(item) {
      this.$router.push(item.link);
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.class-item {
  display: flex;
  border-radius: 8px;
  box-shadow: 0 7px 16px 0 rgba(0, 0, 0, 0.13);
  background: #fff;
  padding: 10px;
  cursor: pointer;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 240px;

  &-title {
    color: #6d6d6d;
    display: block;
  }

  &:hover {
    background: #f8f8f8;
  }
}
</style>
